export default __webpack_public_path__ + "static/media/SmallSBAcceptableMovementEdited.87bb0361.png";